import * as React from "react";
import { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
  Typography,
  Box,
  Chip,
  Divider,
  Grid
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import ImageIcon from "@mui/icons-material/Image";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import { convertTo12HourFormat } from "../data/Utils";
import { IMAGE_BASE_URL } from "../data/API_LINKS";
import { createNewGift, updateGift, deleteGift } from "../data/API";
import { set } from "date-fns";
import { EmojiEvents, HourglassEmpty, NoBackpack } from "@mui/icons-material";

export default function VendorGifts({ vendor, onItemsSelection, loadData, onBackClickListener }) {
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedGift, setSelectedGift] = useState(null);



  const [newGift, setNewGift] = useState({
    kitchen_id: vendor.id,
    name: "",
    points: "",
    stock: "",
    description: "",
    image: null
  });

  const [editGift, setEditGift] = useState({
    id: "",
    kitchen_id: vendor.id,
    name: "",
    points: "",
    stock: "",
    description: "",
    
    image: null
  });

  const [previewImage, setPreviewImage] = useState(null);
  const [editPreviewImage, setEditPreviewImage] = useState(null);

  const handleOpenCreateDialog = () => {
    setOpenCreateDialog(true);
  };

  const handleCloseCreateDialog = () => {
    setOpenCreateDialog(false);
    setNewGift({
      kitchen_id: vendor.id,
      name: "",
      points: "",
      stock: "",
      description: "",
      image: null
    });
    setPreviewImage(null);
  };

  const handleOpenEditDialog = (gift, e) => {
    e.stopPropagation(); // Prevent row click event
    setSelectedGift(gift);
    setEditGift({
      id: gift.id,
      kitchen_id: vendor.id,
      name: gift.name,
      points: gift.points,
      stock: gift.stock,
      description: gift.description || "",
      expire_date: gift.expire_date || null,
      image: gift.image || null
    });
    setEditPreviewImage(gift.image ? IMAGE_BASE_URL + gift.image : null);
    setOpenEditDialog(true);
  };

  const handleCloseEditDialog = () => {
    setOpenEditDialog(false);
    setSelectedGift(null);
    setEditGift({
      id: "",
      kitchen_id: vendor.id,
      name: "",
      points: "",
      stock: "",
      description: "",
      image: null
    });
    setEditPreviewImage(null);
  };

  const handleOpenDeleteDialog = (gift, e) => {
    e.stopPropagation(); // Prevent row click event
    setSelectedGift(gift);
    setOpenDeleteDialog(true);
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
    setSelectedGift(null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewGift({
      ...newGift,
      [name]: value
    });
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditGift({
      ...editGift,
      [name]: value
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setNewGift({
        ...newGift,
        image: file
      });

      // Create preview URL
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleEditImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setEditGift({
        ...editGift,
        image: file
      });

      // Create preview URL
      const reader = new FileReader();
      reader.onloadend = () => {
        setEditPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmitCreate = async () => {
    console.log("Submitting new gift:", newGift);

    createNewGift(newGift, (err, d) => {
      loadData();
      if (!err) {
        console.log("Gift created successfully:", d);
        vendor.prizes?.push(d['gift']);
        setOpenCreateDialog(false);
      } else {
        console.error("Error creating gift:", err);
      }

    });

    // Close dialog after submission
    handleCloseCreateDialog();
  };

  const handleSubmitEdit = async () => {
    console.log("Updating gift:", editGift);


    if (typeof editGift.image === "string") {
      delete editGift.image;
    }

    updateGift(editGift.id, editGift, (err, d) => {
      loadData();
      handleCloseEditDialog();
      if (!err) {
        console.log("Gift updated successfully:", d);
        vendor.prizes = vendor.prizes.map(gift => gift.id === editGift.id ? d['gift'] : gift);
        setSelectedGift(null);
      } else {
        console.error("Error updating gift:", err);
      }
    });
  };

  const handleDelete = async () => {
    if (selectedGift) {
      console.log("Deleting gift:", selectedGift.id);

      deleteGift(selectedGift.id, (err, d) => {
        loadData();
        handleCloseDeleteDialog();
        if (!err) {
          console.log("Gift deleted successfully:", d);
          vendor.prizes = vendor.prizes.filter(gift => gift.id !== selectedGift.id);
          setSelectedGift(null);
        }
      });
    }
  };

  return (
    <Box sx={{ padding: 2 }}>

      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
        <Typography variant="h5" component="h1" fontWeight="bold" className="text-white">
          Available Prizes
        </Typography>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={handleOpenCreateDialog}
        >
          Create New Gift
        </Button>
      </Box>



      <TableContainer component={Paper} elevation={2}>
        {vendor.prizes && vendor.prizes.length > 0 ? (
          <Table aria-label="gifts table">
            <TableHead sx={{ backgroundColor: "#f7f7f7" }}>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold' }}>GIFT</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }} align="center">POINTS</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }} align="center">STOCK</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }} align="center">CREATED AT</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }} align="center">ACTIONS</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {vendor.prizes.map((row) => (
                <TableRow
                  onClick={() => onItemsSelection(row.given_gifts)}
                  key={row.id}
                  sx={{
                    cursor: "pointer",
                    transition: "background-color 0.2s",
                    "&:hover": { backgroundColor: "#f5f5f5" },
                    "&:last-child td, &:last-child th": { border: 0 }
                  }}
                >
                  <TableCell>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Box
                        sx={{
                          width: 40,
                          height: 40,
                          borderRadius: "50%",
                          overflow: "hidden",
                          border: "2px solid #eaeaea",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center"
                        }}
                      >
                        <img
                          src={IMAGE_BASE_URL + row.image}
                          alt={row.name}
                          style={{ width: "100%", height: "100%", objectFit: "cover" }}
                        />
                      </Box>
                      <Typography variant="body1" sx={{ ml: 2, fontWeight: 500 }}>
                        {row.name}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell align="center">
                    <Chip label={`${row.points} PTS`} color="success" variant="outlined" sx={{ fontWeight: 500 }} />
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body2">{row.stock} ITEMS</Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body2" color="text.secondary">
                      {convertTo12HourFormat(row.created_at.split("T")[1].split(".")[0])}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <IconButton onClick={(e) => handleOpenEditDialog(row, e)} size="small" color="primary">
                      <EditIcon fontSize="small" />
                    </IconButton>
                    <IconButton size="small" color="error" onClick={(e) => handleOpenDeleteDialog(row, e)}>
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: 300, p: 4 }}>
            <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center', alignItems: 'center', bgcolor: '#f7f7f7', borderRadius: '50%', width: 80, height: 80 }}>
              <EmojiEvents color="disabled" sx={{ fontSize: 40 }} />
            </Box>
            <Typography variant="h6" color="text.secondary">
              No prizes available
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Start adding prizes to see them here.
            </Typography>
          </Box>
        )}
      </TableContainer>



      {/* Create New Gift Dialog */}
      <Dialog
        fullScreen
        open={openCreateDialog}
        onClose={handleCloseCreateDialog}
        sx={{
          "& .MuiDialog-paper": {
            backgroundColor: "#fafafa"
          }
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2, backgroundColor: "#fff", boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Typography variant="h6" component="div">
              Create New Gift
            </Typography>
            <IconButton
              edge="end"
              color="inherit"
              onClick={handleCloseCreateDialog}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 4 }}>
          <Grid container spacing={4}>
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  border: "2px dashed #ccc",
                  borderRadius: 2,
                  p: 2,
                  height: 300,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#fff",
                  position: "relative",
                  overflow: "hidden"
                }}
              >
                {previewImage ? (
                  <>
                    <img
                      src={previewImage}
                      alt="Gift preview"
                      style={{ maxWidth: "100%", maxHeight: "240px", objectFit: "contain" }}
                    />
                    <IconButton
                      size="small"
                      color="error"
                      sx={{ position: "absolute", top: 8, right: 8, backgroundColor: "rgba(255,255,255,0.8)" }}
                      onClick={() => {
                        setPreviewImage(null);
                        setNewGift({ ...newGift, image: null });
                      }}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </>
                ) : (
                  <>
                    <ImageIcon sx={{ fontSize: 60, color: "#aaa", mb: 2 }} />
                    <Typography variant="body2" color="text.secondary" textAlign="center" mb={2}>
                      Drag and drop an image here or click to upload
                    </Typography>
                  </>
                )}
                <input
                  accept="image/*"
                  id="gift-image-upload"
                  type="file"
                  hidden
                  onChange={handleImageChange}
                />
                <label htmlFor="gift-image-upload">
                  <Button
                    variant="outlined"
                    component="span"
                    size="small"
                  >
                    Browse Files
                  </Button>
                </label>
              </Box>
            </Grid>
            <Grid item xs={12} md={8}>
              <Box sx={{ backgroundColor: "#fff", borderRadius: 2, p: 3, boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <TextField
                      name="name"
                      label="Gift Name"
                      variant="outlined"
                      fullWidth
                      value={newGift.name}
                      onChange={handleChange}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      name="points"
                      label="Points"
                      variant="outlined"
                      fullWidth
                      value={newGift.points}
                      onChange={handleChange}
                      type="number"
                      InputProps={{
                        endAdornment: <Typography color="green" variant="body2">PTS</Typography>
                      }}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      name="stock"
                      label="Stock"
                      variant="outlined"
                      fullWidth
                      value={newGift.stock}
                      onChange={handleChange}
                      type="number"
                      InputProps={{
                        endAdornment: <Typography color="green" variant="body2">ITEMS</Typography>
                      }}
                      required
                    />
                  </Grid>
                  {/* New Expiration Date Field */}
                  <Grid item xs={12} sm={6}>
                    <TextField
                      name="expire_date"
                      label="Expiration Date"
                      variant="outlined"
                      type="date"
                      fullWidth
                      value={newGift.expire_date || ""}
                      onChange={handleChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        inputProps: { min: new Date().toISOString().split('T')[0] }
                      }}
                      helperText="When this gift will expire"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      name="description"
                      label="Description"
                      variant="outlined"
                      fullWidth
                      value={newGift.description}
                      onChange={handleChange}
                      multiline
                      rows={4}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 3, backgroundColor: "#fff", borderTop: "1px solid #eaeaea" }}>
          <Button onClick={handleCloseCreateDialog} color="inherit">
            Cancel
          </Button>
          <Button
            onClick={handleSubmitCreate}
            variant="contained"
            color="primary"
            disabled={!newGift.name || !newGift.points || !newGift.stock || !newGift.image}
          >
            Create Gift
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Gift Dialog */}
      <Dialog
        fullScreen
        open={openEditDialog}
        onClose={handleCloseEditDialog}
        sx={{
          "& .MuiDialog-paper": {
            backgroundColor: "#fafafa"
          }
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2, backgroundColor: "#fff", boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Typography variant="h6" component="div">
              Edit Gift
            </Typography>
            <IconButton
              edge="end"
              color="inherit"
              onClick={handleCloseEditDialog}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 4 }}>
          <Grid container spacing={4}>
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  border: "2px dashed #ccc",
                  borderRadius: 2,
                  p: 2,
                  height: 300,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#fff",
                  position: "relative",
                  overflow: "hidden"
                }}
              >
                {editPreviewImage ? (
                  <>
                    <img
                      src={editPreviewImage}
                      alt="Gift preview"
                      style={{ maxWidth: "100%", maxHeight: "240px", objectFit: "contain" }}
                    />
                    <IconButton
                      size="small"
                      color="error"
                      sx={{ position: "absolute", top: 8, right: 8, backgroundColor: "rgba(255,255,255,0.8)" }}
                      onClick={() => {
                        setEditPreviewImage(null);
                        setEditGift({ ...editGift, image: null });
                      }}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </>
                ) : (
                  <>
                    <ImageIcon sx={{ fontSize: 60, color: "#aaa", mb: 2 }} />
                    <Typography variant="body2" color="text.secondary" textAlign="center" mb={2}>
                      Drag and drop an image here or click to upload
                    </Typography>
                  </>
                )}
                <input
                  accept="image/*"
                  id="edit-gift-image-upload"
                  type="file"
                  hidden
                  onChange={handleEditImageChange}
                />
                <label htmlFor="edit-gift-image-upload">
                  <Button
                    variant="outlined"
                    component="span"
                    size="small"
                  >
                    Browse Files
                  </Button>
                </label>
              </Box>
            </Grid>
            <Grid item xs={12} md={8}>
              <Box sx={{ backgroundColor: "#fff", borderRadius: 2, p: 3, boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <TextField
                      name="name"
                      label="Gift Name"
                      variant="outlined"
                      fullWidth
                      value={editGift.name}
                      onChange={handleEditChange}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      name="points"
                      label="Points"
                      variant="outlined"
                      fullWidth
                      value={editGift.points}
                      onChange={handleEditChange}
                      type="number"
                      InputProps={{
                        endAdornment: <Typography color="green" variant="body2">PTS</Typography>
                      }}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      name="stock"
                      label="Stock"
                      variant="outlined"
                      fullWidth
                      value={editGift.stock}
                      onChange={handleEditChange}
                      type="number"
                      InputProps={{
                        endAdornment: <Typography color="green" variant="body2">ITEMS</Typography>
                      }}
                      required
                    />
                  </Grid>
                  {/* New Expiration Date Field */}
                  <Grid item xs={12} sm={6}>
                    <TextField
                      name="expire_date"
                      label="Expiration Date"
                      variant="outlined"
                      type="date"
                      fullWidth
                      value={editGift.expire_date || ""}
                      onChange={handleEditChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        inputProps: { min: new Date().toISOString().split('T')[0] }
                      }}
                      helperText="When this gift will expire"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      name="description"
                      label="Description"
                      variant="outlined"
                      fullWidth
                      value={editGift.description}
                      onChange={handleEditChange}
                      multiline
                      rows={4}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 3, backgroundColor: "#fff", borderTop: "1px solid #eaeaea" }}>
          <Button onClick={handleCloseEditDialog} color="inherit">
            Cancel
          </Button>
          <Button
            onClick={handleSubmitEdit}
            variant="contained"
            color="primary"
            disabled={!editGift.name || !editGift.points || !editGift.stock}
          >
            Update Gift
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={openDeleteDialog}
        onClose={handleCloseDeleteDialog}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogTitle id="delete-dialog-title">
          Confirm Delete
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" id="delete-dialog-description">
            Are you sure you want to delete the gift "{selectedGift?.name}"? This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="inherit">
            Cancel
          </Button>
          <Button onClick={handleDelete} color="error" variant="contained">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}